import { HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

export const WithdrawalLoadingTablet: React.FC = () => {
  return (
    <TableContent
      direction="column"
      space={Spacing['stack.nano']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <HStack space={Spacing['stack.nano']} width="100%">
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
        </VStack>
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
        </VStack>
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
        </VStack>
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
        </VStack>
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
          <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} width="100%" />
        </VStack>
      </HStack>
    </TableContent>
  );
};
